import styled, { css } from 'styled-components'
import { colors, derivedColors, withScrollbarStyled } from '../../const'

export const Container = styled.section`
  background-color: ${colors.surface};
  box-shadow:
    0px 0px 1px rgba(0, 0, 0, 0.06),
    0px 0px 2px rgba(0, 0, 0, 0.04),
    0px 0px 5px rgba(0, 0, 0, 0.04),
    0px 0px 17px rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  font-family: 'Inter';
  gap: 20px;
  overflow-y: auto;
  padding: 20px;
  width: 45%;

  ${withScrollbarStyled}

  @media screen and (max-width: 1280px) {
    max-height: none;
    width: 100%;
  }
`

export const Header = styled.header`
  align-items: flex-start;
  border-bottom: 2px solid rgba(152, 162, 179, 0.3);
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-bottom: 12px;
`

export const HeaderRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const Title = styled.h2`
  color: ${colors.primary};
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0;
`

export const HeaderBadge = styled.span`
  background-color: rgba(37, 99, 235, 0.1);
  border: 1px solid rgba(37, 99, 235, 0.25);
  border-radius: 999px;
  color: ${colors.primary};
  font-size: 0.69rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 3px 8px;
  text-transform: uppercase;
`

export const Description = styled.p`
  color: ${colors.textPrimary};
  font-size: 0.82rem;
  margin: 0;
`

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const SectionTitle = styled.h3`
  color: ${colors.textSecondary};
  font-size: 0.98rem;
  font-weight: 700;
  margin: 0;
`

export const TwoColumns = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const Label = styled.label`
  color: ${colors.textPrimary};
  font-size: 0.75rem;
  font-weight: 600;
`

export const Select = styled.select`
  background-color: ${colors.surface};
  border: 1px solid rgba(19, 34, 149, 0.1);
  border-bottom-width: 2px;
  border-radius: 6px;
  font-family: 'Inter';
  font-size: 0.875rem;
  min-height: 40px;
  padding: 8px 10px;
  width: 100%;

  &:focus {
    background-color: ${colors.surface};
    border-bottom-color: ${colors.primary};
    outline: none;
  }
`

export const TextInput = styled.input`
  background-color: ${colors.surface};
  border: 1px solid rgba(19, 34, 149, 0.1);
  border-bottom-width: 2px;
  border-radius: 6px;
  font-family: 'Inter';
  font-size: 0.875rem;
  min-height: 40px;
  padding: 8px 10px;
  width: 100%;

  &:focus {
    background-color: ${colors.surface};
    border-bottom-color: ${colors.primary};
    outline: none;
  }
`

export const TextArea = styled.textarea(
  ({ $active, $compact }) => css`
    background-color: ${$active ? colors.surface : derivedColors.subtleSurface};
    border: 1px solid ${$active ? 'rgba(19, 34, 149, 0.22)' : colors.borderSubtle};
    border-radius: 6px;
    color: ${colors.textPrimary};
    font-family: 'Inter';
    font-size: 0.82rem;
    line-height: 1.35;
    min-height: ${$compact ? '104px' : '220px'};
    opacity: ${$active ? 1 : 0.7};
    padding: 10px 12px;
    resize: vertical;
    width: 100%;

    &:focus {
      border-color: ${colors.primary};
      outline: none;
    }
  `
)

export const EyeCard = styled.div(
  ({ $active }) => css`
    background: ${$active ? 'rgba(37, 99, 235, 0.06)' : colors.surface};
    border: 1px solid ${$active ? 'rgba(37, 99, 235, 0.4)' : 'rgba(19, 34, 149, 0.1)'};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 10px;
  `
)

export const EyeTitle = styled.p(
  ({ $disabled }) => css`
    color: ${$disabled ? '#8A93A3' : colors.textPrimary};
    font-size: 0.8rem;
    font-weight: 700;
    margin: 0;
  `
)

export const Hint = styled.p`
  color: ${colors.textSecondary};
  font-size: 0.75rem;
  margin: 0;
`

export const Divider = styled.div`
  background-color: rgba(211, 218, 230, 0.6);
  height: 1px;
  width: 100%;
`

export const WarningMessage = styled.div`
  background-color: #fff3f3;
  color: #d32f2f;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 0.875rem;
  border: 1px solid #ffcdd2;
`
